import { PageHeader } from "../components/nk/PageHeader";
import { Booking } from "../components/nk/Booking";
import { Seo } from "../components/nk/Seo";

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Book an Appointment — Wedding Gowns & Alterations · Perth | NK Bridal"
        description="Book a private bridal appointment with NK Bridal in Perth. Australia-wide online consults and quoting, with regular visits to Brisbane. Begin your fitting today."
        path="/contact"
      />
      <PageHeader
        eyebrow="Book Appointment"
        title={["Begin your", "fitting"]}
        intro="Private appointments by the sketch — based in Perth and travelling Australia-wide, with online quoting and design consults for interstate brides."
      />
      <Booking hideHeading />
    </>
  );
}
